import { useEffect, useRef } from "react";

export default function Snowfall({ count = 70, className = "" }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let raf;
        let flakes = [];

        const resize = () => {
            const dpr = Math.min(window.devicePixelRatio || 1, 2);
            canvas.width = canvas.offsetWidth * dpr;
            canvas.height = canvas.offsetHeight * dpr;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };
        resize();

        const spawn = (initial) => ({
            x: Math.random() * canvas.offsetWidth,
            y: initial ? Math.random() * canvas.offsetHeight : -6,
            r: 0.7 + Math.random() * 1.7,
            speed: 0.25 + Math.random() * 0.75,
            drift: 0.3 + Math.random() * 0.7,
            phase: Math.random() * Math.PI * 2,
            alpha: 0.25 + Math.random() * 0.5,
        });

        flakes = Array.from({ length: count }, () => spawn(true));

        const tick = (t) => {
            ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
            for (const f of flakes) {
                f.y += f.speed;
                f.x += Math.sin(t / 1600 + f.phase) * f.drift * 0.4;
                if (f.y > canvas.offsetHeight + 8 || f.x < -10 || f.x > canvas.offsetWidth + 10) {
                    Object.assign(f, spawn(false));
                }
                ctx.beginPath();
                ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(248,246,240,${f.alpha})`;
                ctx.fill();
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);

        window.addEventListener("resize", resize);
        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
        };
    }, [count]);

    return (
        <canvas
            ref={canvasRef}
            aria-hidden="true"
            className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
        />
    );
}
